var tag = "https://shopfront-cdn.tekoapis.com/static/08ed682a05c137e9.svg";

export { tag as default };
